<!--
  上传组件
  props:
    attrValue: 绑定值
    defaultList: 默认文件/图片列表
    type: 类型：图片 or 文件
  引入地址：
  import vUpload from 'components/fieldtype/upload'
 -->

<template>
  <div class="upload">
    <el-upload
      ref="upload"
      v-if="type === 'image'"
      :action="uploadUlr"
      :data="uploadData"
      :accept="imgAccept"
      :file-list="fileList"
      :on-remove="imgRemove"
      :on-success="imgAdd"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
      :limit="9"
      :disabled="disabled"
      :on-exceed="fileUploadLimitHook"
      >
      <el-button size="small" type="primary" @click="set_upload_param(disabled)" :disabled="disabled">上传图片</el-button>
      <div class="el-upload__tip" slot="tip">只能上传图片文件，最多上传9张</div>
    </el-upload>
    <el-upload
      v-if="type === 'file'"
      ref="upload"
      :action="uploadUlr"
      :data="uploadData"
      :file-list="fileList"
      :on-remove="fileRemove"
      :on-success="fileAdd"
      :on-error="handleError"
      :before-upload="handleBeforeUpload"
      :limit="9"
      :disabled="disabled"
      :on-exceed="fileUploadLimitHook"
      >
      <el-button size="small" type="primary" @click="set_upload_param(disabled)" :disabled="disabled">上传文件</el-button>
      <div class="el-upload__tip" slot="tip">最多上传9个文件</div>
    </el-upload>
  </div>
</template>

<script>
import * as api from 'src/api'
import uploadMix from 'src/config/upload-mixin'

export default {
  props: {
    attrValue: { // 上传文件存放的数组
      type: Array,
      required: true
    },
    defaultList: {
      type: String
    },
    type: { // 上传类型
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  created () {
    let defaultArray
    if (this.attrValue) {
      defaultArray = JSON.parse(JSON.stringify(this.attrValue))
    } else {
      defaultArray = window.utils.json(this.defaultList)
    }
    // 将props进来的图片或文件进行格式化
    if (defaultArray) {
      if (this.type === 'image') {
        this.fileList = defaultArray.map((item) => {
          return {
            // 使用正则从URL中获取文件名
            name: item.replace(/.+\/|\?.+/g, ''),
            url: item
          }
        })
      } else {
        this.fileList = defaultArray.map((item) => {
          return {
            name: item.filename,
            url: item.attachIndex
          }
        })
      }
    }
  },
  data () {
    return {
      apiUrl: api.path,
      fileList: []
    }
  },
  mixins: [uploadMix],
  methods: {
    imgAdd (response, file) {
      let newImg = this.fileUrl[file.uid] + '?' + file.uid
      this.attrValue.push(newImg)
    },
    // 判断文件名或uid，有任意一个则视为相等
    imgRemove (file) {
      if (file) {
        let arr = this.attrValue
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].indexOf(file.url) > -1 || arr[i].indexOf(file.uid) > -1) {
            arr.splice(i, 1)
          }
        }
      }
    },

    fileAdd (response, file) {
      let newFile = {
        filename: file.name,
        attachIndex: this.fileUrl[file.uid],
        ext: file.name.replace(/.+\./, '').toLowerCase(),
        size: file.size,
        uid: file.uid
      }
      this.attrValue.push(newFile)
    },
    // 判断文件名或uid，有任意一个则视为相等
    fileRemove (file) {
      if (file) {
        let arr = this.attrValue
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].attachIndex === file.url || arr[i].uid === file.uid) {
            arr.splice(i, 1)
          }
        }
      }
    },
    // 清空上传列表
    clearUploadFiles () {
      this.$refs.upload.abort() // 结束所有上传进程
      this.$refs.upload.clearFiles() // 附件和图片公用一套，只会存在一个组件
    }
  }
}
</script>



// WEBPACK FOOTER //
// upload.vue?575089dd